// Vendored version of the Maybe type from graphql so we can support different graphql versions where it has moved around
export type Maybe<T> = null | undefined | T;
